/**
 * Keeps the end of a long value visible inside text inputs (such as long email
 * addresses in the newsletter forms). Browsers scroll back to the start of the
 * value once the field loses focus, which hides the characters the customer
 * typed last, so the field is scrolled back to the end here.
 */
(() => {
  const SELECTOR = 'input.input, input.field';

  const scrollToEnd = (input) => {
    if (!input.value) return;

    const isRtl = getComputedStyle(input).direction === 'rtl';
    input.scrollLeft = isRtl ? -input.scrollWidth : input.scrollWidth;
  };

  document.addEventListener('focusout', (event) => {
    const input = event.target;

    if (input instanceof HTMLInputElement && input.matches(SELECTOR)) {
      scrollToEnd(input);
    }
  });

  // Values restored by the browser (autofill, back/forward cache) do not fire any event.
  window.addEventListener('pageshow', () => {
    for (const input of document.querySelectorAll(SELECTOR)) {
      scrollToEnd(input);
    }
  });
})();

/**
 * Rebuy's Smart Cart returns focus to the header cart link when it closes. Because the theme
 * reserves the sticky header with scroll-padding-block-start on <html>, Chrome scrolls that
 * link clear of the sticky area, which yanks the page up by the sticky-area height on every
 * close. Focus is still restored for keyboard users, just without the scroll.
 */
(() => {
  const SELECTOR = '[data-cart-trigger="rebuy"]';
  const nativeFocus = HTMLElement.prototype.focus;

  const patch = (element) => {
    if (element.dataset.preventScrollFocus) return;
    element.dataset.preventScrollFocus = 'true';
    element.focus = function (options) {
      return nativeFocus.call(this, { ...options, preventScroll: true });
    };
  };

  const patchAll = () => document.querySelectorAll(SELECTOR).forEach(patch);

  patchAll();

  // The header is re-rendered when the cart changes, which replaces the patched element.
  new MutationObserver(patchAll).observe(document.documentElement, { childList: true, subtree: true });
})();
